import { env } from '@shared/config';
import { isMobile } from '@shared/lib';
import { isAndroid } from '@shared/webview';
import { AppLocale, defaultLocale } from '@shared/i18n';
import { getAppContext } from '@shared/app-context';

const localeToAcceptLanguage = {
  [AppLocale.RU]: 'ru',
  [AppLocale.KK]: 'kk',
};

const getAcceptLanguageByLocale = () => {
  const { locale } = getAppContext();

  return locale in localeToAcceptLanguage
    ? localeToAcceptLanguage[locale]
    : localeToAcceptLanguage[defaultLocale];
};

const webConsumers = {
  desktop: {
    key: env.PFM_DESKTOP_CONSUMER_KEY,
    name: env.PFM_DESKTOP_CONSUMER_NAME,
  },
  mobile: {
    key: env.PFM_MOBILE_CONSUMER_KEY,
    name: env.PFM_MOBILE_CONSUMER_NAME,
  },
};

/**
 * For webview we should use the native apps' consumer: iOS, Android
 */
const webviewConsumers = {
  ios: {
    key: env.PFM_IOS_CONSUMER_KEY,
    name: env.PFM_IOS_CONSUMER_NAME,
  },
  android: {
    key: env.PFM_ANDROID_CONSUMER_KEY,
    name: env.PFM_ANDROID_CONSUMER_NAME,
  },
};

/**
 * TODO: Maybe create a method that returns the setup instance based on params
 */
const getConsumerTokenCredentials = () => {
  const appContext = getAppContext();

  if (appContext.isWebview) {
    return isAndroid() ? webviewConsumers.android : webviewConsumers.ios;
  }

  return isMobile() ? webConsumers.mobile : webConsumers.desktop;
};

export const apiLib = {
  getAcceptLanguageByLocale,
  getConsumerTokenCredentials,
};
